import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=544a1167"
import script from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports